'use strict';

var ajax = require('../../ajax'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');



/**
 * @private
 * @function
 * @description Binds events to the order confirmation page
 */
function initializeEvents() {
    $(document).on('ready', function (e) {
        var url = Urls.checkoutSubscription;
        var orderId = $(".order-number .value").text();
        if ($("[name='sms-sign-up']").length > 0 && orderId && orderId.length > 0) {
            url = util.appendParamToURL(url, 'orderId', orderId);
            ajax.getJson({
                url: url,
                callback: function (data) {
                    //@todo
                    //Error scenarios handled on order confirmation page store
                    if(!data.success){
                        $(".order-confirmation-details .order-information").after('<div class=\"sms-vibes-error\"><span>!</span><p>'+Resources.CHECKOUT_SMS_VIBES_ERROR_MSG+'</p><button onclick="smsOptModal.open()">'+Resources.CHECKOUT_SMS_VIBES_REENTER_TXT+'</button></div>');
                    }                    
                }
            });
        }
    });
}

exports.init = function () {
    initializeEvents();
};
